import 'onsenui/css/onsenui.css';
import 'onsenui/css/onsen-css-components.css';

import Vue from 'vue';
import VueOnsen from 'vue-onsenui';
Vue.use(VueOnsen);

import App from "./App.vue";
import "./registerServiceWorker";

Vue.config.productionTip = false;
import { Plugin } from 'vue-fragment';
Vue.use(Plugin);

new Vue({
  render: h => h(App)
}).$mount("#app");
